import {
  $createTextNode,
  $isElementNode,
  $isTextNode,
  type ElementNode,
  type LexicalNode,
  type TextNode,
} from "lexical"

import {
  findPlaceholderByNormalizedValue,
  LIQUID_PLACEHOLDER_REGEX,
  type PlaceholderData,
} from "@/components/lexical/placeholders"

import { $createPlaceholderNode } from "../nodes/placeholder/node"

function replaceInTextNode(textNode: TextNode) {
  if (textNode.isToken()) return

  const textContent = textNode.getTextContent()
  LIQUID_PLACEHOLDER_REGEX.lastIndex = 0

  const matches: Array<{ start: number; end: number; placeholder: PlaceholderData }> = []
  let match: RegExpExecArray | null

  while ((match = LIQUID_PLACEHOLDER_REGEX.exec(textContent)) !== null) {
    const matchedValue = match[0]
    const placeholder = findPlaceholderByNormalizedValue(matchedValue)
    if (placeholder) {
      matches.push({ start: match.index, end: match.index + matchedValue.length, placeholder })
    }
  }

  if (matches.length === 0) return

  const newNodes: LexicalNode[] = []
  let cursor = 0

  for (const entry of matches) {
    if (entry.start > cursor) {
      newNodes.push($createTextNode(textContent.slice(cursor, entry.start)))
    }

    newNodes.push(
      $createPlaceholderNode(
        entry.placeholder.label,
        entry.placeholder.value,
        entry.placeholder.id,
        entry.placeholder.description
      )
    )

    cursor = entry.end
  }

  if (cursor < textContent.length) {
    newNodes.push($createTextNode(textContent.slice(cursor)))
  }

  if (newNodes.length === 0) return

  textNode.replace(newNodes[0])
  for (let index = 1; index < newNodes.length; index++) {
    newNodes[index - 1].insertAfter(newNodes[index])
  }
}

function walk(element: ElementNode) {
  const children = element.getChildren()
  for (const child of children) {
    if ($isElementNode(child)) {
      walk(child)
    } else if ($isTextNode(child)) {
      replaceInTextNode(child)
    }
  }
}

export function replaceLiquidPlaceholdersInRoot(root: ElementNode) {
  walk(root)
}
